export const calculateCanvasSize = (badgeSize) => {
  if (badgeSize.width > badgeSize.height) {
    const unadaptedWidth = badgeSize.width * 200;
    const width = unadaptedWidth > 600 ? 600 : unadaptedWidth;

    return {
      height: (width * badgeSize.height) / badgeSize.width,
      width,
    }
  } else {
    const unadaptedHeight = badgeSize.height * 100;
    const height = unadaptedHeight > 600 ? 600 : unadaptedHeight;

    return {
      height,
      width: (height * badgeSize.width) / badgeSize.height
    }
  }
}